module.exports = "<div class=mui-flexbox-item :style=\"{marginLeft: $parent.supported ? $parent.marginLeft + 'px' : 0}\"> <slot></slot> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flexbox-item/index.vue
 ** module id = 158
 ** module chunks = 0
 **/